module.exports = "h1 {\r\n    color: #00579e;\r\n    font-size: 2em;\r\n}\r\n\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/app_manager/app_element/client-detail/communication/communication.component.css
// module id = ./src/app/app_manager/app_element/client-detail/communication/communication.component.css
// module chunks = main